import { Component, OnInit, Input } from '@angular/core';
import { CaseData } from '../../shared/models/caseValidation';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
@Component({
    selector: 'Case-Template-Field',
    templateUrl: '../case-template/caseTemplateField.component.html'
})

export class CaseTemplateFieldComponent implements OnInit {
    @Input() field: any;
    @Input() value: any;
    @Input() IsRequired: boolean;
    @Input() ParentFormGrp: FormGroup;
    @Input() modalData;
    oldValue: any;
    formCtrl: FormControl;
    isReady = false;

    constructor() {
    }

    ngOnInit() {
        this.formCtrl = this.field.Required? new FormControl('', Validators.required): new FormControl(this.value);
        this.ParentFormGrp.addControl(this.field.Name, this.formCtrl);
        if (this.field.Type == 'Checkbox' && this.value) {
            this.value = (this.value.toString().toLowerCase() == 'true');
        }
        if (this.field.Type == 'MultiSelection' && this.value && !Array.isArray(this.value)) {
            this.value = this.value.split(',');

            this.AddNonMatchingOptions();
        }
        const isValid = !this.value && this.field.Required ? false : true;
        this.setValidationRule();
        this.isReady = true;
        this.oldValue = this.value;
    }

    private setValidationRule(): void {
        CaseData.setCaseData({
            key: this.field.Name, IsRequired: this.field.Required,
            value: this.value, Type: this.field.Type
        });
    }

    private AddNonMatchingOptions(){
        let nonMatchingOptions = this.value.filter(v => {
            let descriptions = this.field.MultiSelect.map(ms => ms.Description);
            let matchingIndex = _.findIndex(descriptions, d => d == v);

            return matchingIndex < 0;
        });

        nonMatchingOptions.forEach(option => {
            let newOption = {
                "Name": `${this.field.Name}${option}`,
                "Description": option,
                "Type": "Checkbox",
                "Required": false,
                "Options": [
                    "True",
                    "False"
                ]
            };

            this.field.MultiSelect.push(newOption);
        });
    }

    private update(validationControl: any, value: any) {
       if(this.oldValue != value){
        this.oldValue = value;
        this.field.value = value;
        this.value =  value;
        this.setValidationRule();
        this.formCtrl.setValue(value) ;
        this.ParentFormGrp.removeControl(this.field.Name);
        this.ParentFormGrp.addControl(this.field.Name, this.formCtrl);
    
        this.modalData[this.field.Name] = value
        CaseData.changeset[this.field.Name] = (this.field.Type == 'MultiSelection' && this.value != null)?  this.value.toString(): value;
        CaseData.OnChange();
       }
        
    }

    private isValid(validationControl: any): boolean {
        if (validationControl.errors) {
            return this.isRequired(validationControl);
        }

        return true;
    }

    private isRequired(validationControl: any): boolean {
        if ((this.field.Type == 'Date' && this.field.Required
            && (!this.value && this.value.trim().length == 0))) {
            return false;
        } else if (this.field.Type == 'Date' && this.value && this.value.trim().length > 0) {
            return true;
        } else if (validationControl.errors.required && this.value) {
            return true;
        } else {
            return false;
        }
    }
}
